import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DRILLDOWN_COLLAPSE_TRIGGER_SX } from './analyticsDrilldownStyles';

/**
 * Shared section chrome for analytics drill-down lists.
 */
const DrilldownSectionHeader = ({
  title = 'Recent activity',
  countLabel,
  helperText,
  collapsible = false,
  open = true,
  onToggle,
}) => {
  const helperBlock = helperText ? (
    <Typography
      component="div"
      sx={{
        fontSize: '0.7rem',
        color: 'rgba(0,0,0,0.45)',
        mt: 0.75,
        lineHeight: 1.35,
        textAlign: 'left',
      }}
    >
      {helperText}
    </Typography>
  ) : null;

  if (collapsible) {
    return (
      <Box sx={{ mb: open ? 1 : 0 }}>
        <ButtonBase onClick={onToggle} sx={DRILLDOWN_COLLAPSE_TRIGGER_SX}>
          <Box sx={{ minWidth: 0, flex: 1, textAlign: 'left' }}>
            <Typography
              sx={{
                fontSize: '0.85rem',
                fontWeight: 500,
                color: 'rgba(0,0,0,0.75)',
                lineHeight: 1.35,
              }}
            >
              {title}
            </Typography>
            {countLabel ? (
              <Typography
                sx={{
                  fontSize: '0.72rem',
                  fontWeight: 400,
                  color: 'rgba(0,0,0,0.42)',
                  mt: 0.25,
                  lineHeight: 1.35,
                }}
              >
                {countLabel}
              </Typography>
            ) : null}
          </Box>
          <ExpandMoreIcon
            sx={{
              fontSize: 18,
              color: 'rgba(0,0,0,0.4)',
              flexShrink: 0,
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 200ms ease',
            }}
          />
        </ButtonBase>
        {helperBlock}
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 1 }}>
      <Typography
        variant="caption"
        component="div"
        sx={{
          color: 'rgba(0,0,0,0.5)',
          fontWeight: 600,
          letterSpacing: 0.4,
          textTransform: 'uppercase',
          fontSize: '0.65rem',
          lineHeight: 1.35,
        }}
      >
        {title}
      </Typography>
      {countLabel ? (
        <Typography
          component="div"
          sx={{
            fontSize: '0.72rem',
            color: 'rgba(0,0,0,0.42)',
            fontWeight: 400,
            mt: 0.35,
            lineHeight: 1.35,
          }}
        >
          {countLabel}
        </Typography>
      ) : null}
      {helperBlock}
    </Box>
  );
};

export default DrilldownSectionHeader;
